module.exports = {
      id: "share-alt-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#share-alt",
      toString: function () {
        return this.url;
      }
    }